import { LoggerService } from "@modules/common/logger/loggerService"
import { LoggerType } from "@modules/utils/loggerUtils"
import { QueryClient } from "@tanstack/react-query"
import { ZodError } from "zod"

export const appQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      throwOnError(error, query) {
        if (error instanceof ZodError) {
          LoggerService.captureException(LoggerType.QueryError + String(query.queryKey), error)
          console.error("ZodError:", error)
          return false
        }
        LoggerService.captureException(LoggerType.QueryError + String(query.queryKey), error)
        return false
      },
    },
  },
})
